import { Authorizer } from "@styleguide";
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const WorkshopsCreate = lazy(() => import("./create"));
const WorkshopsDashboard = lazy(() => import("./dashboard"));
const WorkshopsDetails = lazy(() => import("./details"));
const ErrorPage = lazy(() => import("@root/error"));

export const workshopsRoutes = [
  {
    path: "/workshops/create",
    element: (
      <Authorizer
        requiredPermissions={["workshops.modify"]}
        Authorized={WorkshopsCreate}
        redirect="/v2/candidates/dashboard"
      />
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/workshops/dashboard",
    element: (
      <Authorizer
        requiredPermissions={["workshops.dashboard.visualize"]}
        Authorized={WorkshopsDashboard}
        redirect="/v2/candidates/dashboard"
      />
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/workshops/:id",
    element: (
      <Authorizer
        requiredPermissions={["workshops.visualize"]}
        Authorized={WorkshopsDetails}
        redirect="/v2/candidates/dashboard"
      />
    ),
    errorElement: <ErrorPage />,
  },
] as const satisfies readonly RouteObject[];
